import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    meta: {
      icon: 'mdi:shield-half-full',
      order: 80,
      title: '广告管理',
    },
    name: 'ContentGovernance',
    path: '/content-governance',
    children: [
      {
        name: 'ContentReview',
        path: '/content-review',
        component: () => import('#/views/Ad-governance/ad-review/index.vue'),
        meta: {
          icon: 'mdi:file-check-outline',
          title: '广告审核',
          pageKey: (route) => route.path,
        },
      },
      {
        name: 'AdReview',
        path: '/ad-review',
        component: () =>
          import('#/views/Ad-governance/ad-review-new/index.vue'),
        meta: {
          icon: 'mdi:file-check-outline',
          title: '广告审核（new）',
          pageKey: (route) => route.path,
        },
      },
      {
        name: 'ContentStatus',
        path: '/content-status',
        component: () => import('#/views/Ad-governance/ad-status/index.vue'),
        meta: {
          title: '广告数据',
          icon: 'carbon:align-box-bottom-right',
          keepAlive: true,
        },
      },
      {
        name: 'AdCustomerViolationRegulations',
        path: '/customer-violation-regulations',
        component: () =>
          import(
            '#/views/Ad-governance/customer-violation-regulations/index.vue'
          ),
        meta: {
          icon: 'mdi:alert-circle',
          title: '客户违规广告情况',
          keepAlive: true,
        },
      },
    ],
  },
]

export default routes
